module.exports = __webpack_public_path__ + "static/img/dahang-b.52efdfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/dahang-b.png
// module id = CDWC
// module chunks = 1